import { lazy } from 'react';
// project import
import Loadable from 'components/Loadable';
import { RequireAuthorizedAccess } from 'routes/guards/RequireAuthorizedAccess';
// import Permissions from "const/Permissions";
import AddDataStandardForm from 'pages/basic/crud/AddDataStandardForm';
import EditDataStandardForm from 'pages/basic/crud/EditDataStandardForm';
// import AdminManageData from "pages/admin/admin/AdminManageData";
import DataEntryService from 'services/nostradamus/administration/DataEntryService';

import { DataEntry } from 'models/nostradamus/administration/DataEntry';

import DataEntryConfig from 'pages/nostradamus/administration/data-entry/config/forms/DataEntryConfig';
import EditDataForm from 'pages/nostradamus/administration/data-entry/components/EditDataForm';
import { User } from 'models/nostradamus/user/User';
import UserConfig from 'pages/nostradamus/administration/user/config/forms/UserConfig';
import UserService from 'services/nostradamus/administration/UserService';
import MilitaryUnitService from 'services/nostradamus/administration/MilitaryUnitService';
import { MilitaryUnit } from 'models/nostradamus/administration/MilitaryUnit';
import MilitaryUnitConfig from 'pages/nostradamus/administration/setting/forms/MilitaryUnitConfig';

// import Permissions from "constants/Permissions"; --- IGNORE ---

// ==============================|| ROUTES ITEMS - ADMINS||============================== //

// DataEntry
const DataEntryPage = Loadable(
    lazy(() =>
        import('pages/nostradamus/administration/data-entry/DataEntryPage'),
    ),
);

// Setting
const Settings = Loadable(
    lazy(() => import('pages/nostradamus/administration/setting/SettingPage')),
);

const UsersPage = Loadable(
    lazy(() => import('pages/nostradamus/administration/user/UserPage')),
);

const DemoRequestsPage = Loadable(
    lazy(() =>
        import('pages/nostradamus/administration/demo-requests/DemoRequestPage'),
    ),
);

const SalesRequestsPage = Loadable(
    lazy(() =>
        import('pages/nostradamus/administration/sales-requests/SalesRequestPage'),
    ),
);

const administration = {
    path: 'administration',
    children: [
        {
            path: 'data-entry',
            element: (
                // <RequireAuthorizedAccess permissions={Permissions.Admin.Admins}>
                <DataEntryPage />
                // </RequireAuthorizedAccess>
            ),
            children: [
                {
                    index: true,
                },
                {
                    path: 'create',
                    element: (
                        <AddDataStandardForm
                            navigateTo={'/administration/data-entry'}
                            service={DataEntryService}
                            pageTitle="Add entry"
                            config={DataEntryConfig}
                            entity={DataEntry}
                            slice={'dataEntry'}
                        />
                    ),
                },
                {
                    path: 'edit/:id',
                    element: (
                        <EditDataForm
                            navigateTo={'/administration/data-entry'}
                            service={DataEntryService}
                            pageTitle="Edit entry"
                            config={DataEntryConfig}
                            entity={DataEntry}
                            slice={'dataEntry'}
                        />
                    ),
                },
            ],
        },
        {
            path: 'units',
            element: (
                // <RequireAuthorizedAccess
                //     permissions={Permissions.Admin.Roles}
                // >
                <Settings />
                // </RequireAuthorizedAccess>
            ),
            children: [
                {
                    index: true,
                },
                {
                    path: 'create',
                    element: (
                        <AddDataStandardForm
                            navigateTo={'/administration/units'}
                            service={MilitaryUnitService}
                            pageTitle="Add Unit"
                            config={MilitaryUnitConfig}
                            entity={MilitaryUnit}
                            slice={'militaryUnit'}
                        />
                    ),
                },
                {
                    path: 'edit/:id',
                    element: (
                        <EditDataStandardForm
                            navigateTo={'/administration/units'}
                            service={MilitaryUnitService}
                            pageTitle="Edit Unit"
                            config={MilitaryUnitConfig}
                            entity={MilitaryUnit}
                            slice={'militaryUnit'}
                        />
                    ),
                },
            ],
        },
        {
            path: 'users',
            element: (
                // <RequireAuthorizedAccess permissions={Permissions.Admin.Admins}>
                <UsersPage />
                // </RequireAuthorizedAccess>
            ),
            children: [
                {
                    index: true,
                },
                {
                    path: 'create',
                    element: (
                        <AddDataStandardForm
                            navigateTo={'/administration/users'}
                            service={UserService}
                            pageTitle="Add user"
                            config={UserConfig}
                            entity={User}
                            slice={'users'}
                        />
                    ),
                },
                {
                    path: 'edit/:id',
                    element: (
                        <EditDataStandardForm
                            navigateTo={'/administration/users'}
                            service={UserService}
                            pageTitle="Edit user"
                            config={UserConfig}
                            entity={User}
                            slice={'users'}
                        />
                    ),
                },
            ],
        },
        {
            path: 'demo-requests',
            element: <DemoRequestsPage />,
            children: [
                {
                    index: true,
                },
            ],
        },
        {
            path: 'sales-requests',
            element: <SalesRequestsPage />,
            children: [
                {
                    index: true,
                },
            ],
        },
    ],
};

export default administration;
